module.exports = __webpack_public_path__ + "static/media/jen.ff01ae77.webp";